import { State } from 'interfaces/state'
import { createSelector } from 'reselect'
import { createOwnPropsSelector } from 'selectors/globalSelectors'
import { getItemFromCollection } from 'helpers/normalizeHelpers'
import { FloatingPane } from 'interfaces/floatingPanes'

export const floatingPanesCollectionSelector = (state: State) => state.app.floatingPanes.panes
export const createFloatingPaneByTypeSelector = () => {
  const ownPropsSelector = createOwnPropsSelector<{ type: FloatingPane['type'] }>()

  return createSelector(
    floatingPanesCollectionSelector,
    ownPropsSelector,
    (panes, { type }) => getItemFromCollection(panes, type)
  )
}


export const createTopPaneSelector = () => createSelector(
  floatingPanesCollectionSelector,
  (panesCollection) => {
    const lastKey = panesCollection.allKeys[panesCollection.allKeys.length - 1]
    if (!lastKey) {
      return null
    }

    return panesCollection.byKey[lastKey] ?? null
  }
)
